export const B2B_FUNDING_TYPE = {
  COMPANY_FUNDED: 'COMPANY_FUNDED',
  SELF_FUNDED: 'SELF_FUNDED',
}

export const B2B_LOGIN_FAILED_REASONS = {
  NON_WHITELISTED_EMAIL: 'non_whitelisted_email',
  INVALID_OTP: 'invalid_otp',
  EXPIRED_OTP: 'expired_otp',
}

export const B2B_EVENT_ENTITY_TYPE = {
  // eslint-disable-next-line i18next/no-literal-string
  B2B_LOGIN_SUCCESS: 'b2b_login_success',
  // eslint-disable-next-line i18next/no-literal-string
  B2B_LOGIN_FAILED: 'b2b_login_failure',
  // eslint-disable-next-line i18next/no-literal-string
  B2B_LOGIN_EMAIL_SUBMITTED: 'b2b_login_attempt',
  // eslint-disable-next-line i18next/no-literal-string
  B2B_LOGIN_OTP_SUBMITTED: 'b2b_login_otp',
  // eslint-disable-next-line i18next/no-literal-string
  B2B_PAGE_VIEW: 'b2b_login_page',
}
